import TeamResponse from './TeamResponse';

export {
    TeamResponse
};



// WEBPACK FOOTER //
// ./src/api/responses/index.ts